// extracted by mini-css-extract-plugin
var _1 = "TableHeaderRow-moduleTableHeaderRow__bYvrH";
var _2 = "TableHeaderRow-moduleactionColumn__WAOeX TableHeaderRowCell-moduleTableHeaderRowCell__zrJys";
var _3 = "TableHeaderRow-moduleresizing__tnl2k";
export { _1 as "TableHeaderRow", _2 as "actionColumn", _3 as "resizing" }
